import React from 'react';
import clsx from 'clsx';

const FieldErrors = ({ errors, className }) => {
    const uniqueErrors = errors.toOrderedSet().toList();
    if (!uniqueErrors.size) {
        return null;
    }
    return (
        <div className={clsx('nui-label-error fs-12 pb-5', className)}>
            {uniqueErrors.map((error, i) => (
                <div key={i}>{error}</div>
            ))}
        </div>
    );
};
export default FieldErrors;
